import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useNavigation } from "../hooks";

export default function RequireNavigationData() {
  const { data } = useNavigation();
  const location = useLocation();

  if (!data) return <Navigate to="/" replace state={{ from: location }} />;
  return <Outlet context={data} />;
}
